export default window.route
